import { IChildProp } from '@intelligence/components/Form/type';

export const SEGMENT_CASCADER_ALL_VALUE = {
  mscience: [
    'Full Game',
    'MTX',
    'DLC: All Other',
    'DLC: Expansion',
    'DLC: Content Pre-Purchase Pass',
    'DLC: Unlockable Content Pass',
    'Subscription',
  ],
  gsd: ['Full Game', 'In-Game Currency'],
};

export const SEGMENT_CASCADER: IChildProp[] = [
  {
    type: 'cascader',
    hasSelectAll: true,
    hasSearch: true,
    hasShortcut: true,
    mainCategory: 'dbi_data_source',
    subCategory: 'Segment',
    displaySearchParentText: true,
    searchTagAutoWidth: true,
    shortcutOptions: [
      {
        label: 'Base Game',
        labelKey: 'dbi_segment_full_game_key',
        value: 'Full Game',
        includes: {
          mscience: ['Full Game'],
          gsd: ['Full Game'],
        },
      },
    ],
    shortcutDefaultValue: '',
    children: [
      {
        enumKey: 'mscience',
        enumTargetType: 'dataSource',
        children: [
          {
            enumKey: 'fullGame',
            enumTargetType: 'segment',
          },
          {
            enumKey: 'mtx',
            enumTargetType: 'segment',
          },
          {
            enumKey: 'dlcAllOther',
            enumTargetType: 'segment',
          },
          {
            enumKey: 'dlcExpansion',
            enumTargetType: 'segment',
          },
          {
            enumKey: 'dlcBattlePass',
            enumTargetType: 'segment',
          },
          {
            enumKey: 'dlcSeasonPass',
            enumTargetType: 'segment',
          },
          {
            enumKey: 'subscription',
            enumTargetType: 'segment',
          },
        ],
      },
      {
        enumKey: 'gsd',
        enumTargetType: 'dataSource',
        children: [
          {
            enumKey: 'fullGame',
            enumTargetType: 'segment',
          },
          {
            enumKey: 'inGameCurrency',
            enumTargetType: 'segment',
          },
        ],
      },
    ],
  },
];
